import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import {
  GetAuthenticationActivity,
  GetFactoryOptions,
  UpdateAuthenticationActivity,
  UpdateAuthenticationActivityStatus,
  DeleteAuthenticationActivity,
} from './thunks';

import {
  GetAuthenticationActivityReducer,
  UpdateAuthenticationActivityReducer,
  UpdateAuthenticationActivityStatusReducer,
  DeleteAuthenticationActivityReducer,
  ClearSelectedAuthenticationActivityReducer,
  GetFactoryOptionsReducer,
  ResetAuthenticationActivityStateReducer,
} from './reducers';

// ----------------------------------------------------------------------------

// slice
export const slice = createSlice({
  name: 'authenticationActivity',
  initialState,
  reducers: {
    ClearSelectedAuthenticationActivity: ClearSelectedAuthenticationActivityReducer,
    ResetAuthenticationActivityState: ResetAuthenticationActivityStateReducer,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetAuthenticationActivity, GetAuthenticationActivityReducer);
    addExtraReducer(builder, GetFactoryOptions, GetFactoryOptionsReducer);
    addExtraReducer(builder, UpdateAuthenticationActivity, UpdateAuthenticationActivityReducer);
    addExtraReducer(builder, UpdateAuthenticationActivityStatus, UpdateAuthenticationActivityStatusReducer);
    addExtraReducer(builder, DeleteAuthenticationActivity, DeleteAuthenticationActivityReducer);
  },
});

export default slice.reducer;
